// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages90_root__6Qb8W","title":"AfterImages90_title__HLV1a","images":"AfterImages90_images__2ay7s"};